// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//     const isAuthenticated = localStorage.getItem('user') !== null;
    
//     if (!isAuthenticated) {
//         return <Navigate to="/login" replace />;
//     }

//     return children;
// };

// export default ProtectedRoute;


import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const SESSION_CHECK_INTERVAL_MS = 8000; // Check every 8 seconds so old device logs out quickly

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('user') !== null;
    const token = localStorage.getItem('token');

    // One device at a time: verify session immediately and then on interval; 401 = axios interceptor logs out + redirects
    useEffect(() => {
        if (!token || !isAuthenticated) return;
        const baseUrl = process.env.REACT_APP_BASE_URL;
        if (!baseUrl) return;

        const checkSession = () => {
            axios.get(`${baseUrl}/api/verify-session`).catch(() => {});
        };

        checkSession(); // run once on mount
        const intervalId = setInterval(checkSession, SESSION_CHECK_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [token, isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
